import { render, staticRenderFns } from "./AlarmTable.vue?vue&type=template&id=686b6fba&"
import script from "./AlarmTable.vue?vue&type=script&lang=js&"
export * from "./AlarmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports